import { useHistory } from "react-router-dom/cjs/react-router-dom"
import icon_dsda from "../../Assets/png_jpg/dsda.png"

export default function FloodSystemAnalysis(){
    const accesstoken = localStorage.token_mapid
    const history = useHistory()

    return (
        <div
            style={{
                position: "fixed", 
                top: 0, 
                right: 0, 
                bottom: 0, 
                left: 0, 
                width: "100vw", 
                height: "100vh", 
                zIndex: 999
            }}
        >
            <button  style={{
                position: "fixed",
                top: "0.5rem",
                left: "0.6rem",
                zIndex: 999,
                background: "white",
                width: 320,
                borderRadius: ".5rem .5rem 0 0",
                padding: ".5rem",
                textAlign: "left"
            }} onClick={() => {
                history.push("/")
            }}>
                <img src={icon_dsda} alt="" />
            </button>
            <iframe style={{width: "100%", height: "100%"}} src={`https://staging.mapid.io/dsda/sistem-analisa-banjir?token=${accesstoken}`} title="Sistem Analisis Banjir - DSDA Jakarta"/>
        </div>
    )
}